/* eslint-disable object-shorthand */
import swal from 'sweetalert';

export default async function yesNoDialog(
    question: string,
    text?: string,
    icon?: string,
) {
    const response: any = await swal({
        title: question,
        text: text,
        icon: icon,
        buttons: ['não', 'sim'],
    });

    if (response) {
        return true;
    }

    return false;
}
